import { MutationOptions, useMutation } from '@tanstack/react-query';
import useUser from '../global/useUser';
import { UpdatePaymentsRatesPayload } from '../../types/businesses';
import { updatePaymentsRates } from '../../services/business';

type UpdatePaymentsRatesMutationOptions = MutationOptions<
  Awaited<ReturnType<typeof updatePaymentsRates>>,
  Error,
  UpdatePaymentsRatesPayload
>;

interface Options {
  onSuccess?: UpdatePaymentsRatesMutationOptions['onSuccess'];
  onError?: UpdatePaymentsRatesMutationOptions['onError'];
}

function useUpdatePaymentsRates({ onSuccess, onError }: Options = {}) {
  const { user } = useUser();

  return useMutation({
    mutationFn: async (payload: UpdatePaymentsRatesPayload) => {
      if (!user?.business?.id) throw new Error('Business not found');
      const result = await updatePaymentsRates(user.business.id, payload);
      return result;
    },
    onSuccess,
    onError,
  });
}

export default useUpdatePaymentsRates;
